module.exports = __webpack_public_path__ + "static/staff_of_power-0457ef08d7fca03fcbaf09536640e6b0.jpeg";